import React, { useContext, useEffect } from "react";
import { Global, css } from "@emotion/react";
import { LoadContext } from "@providers/LoadProvider";
import UniversLightWoff from "@fonts/univers-light.woff";
import UniversLightWoff2 from "@fonts/univers-light.woff2";
import UniversRomanWoff from "@fonts/univers-roman.woff";
import UniversRomanWoff2 from "@fonts/univers-roman.woff2";
import UniversBoldWoff from "@fonts/univers-bold.woff";
import UniversBoldWoff2 from "@fonts/univers-bold.woff2";
import UniversBoldCondWoff from "@fonts/univers-bold-cond.woff";
import UniversBoldCondWoff2 from "@fonts/univers-bold-cond.woff2";
import GantModernBoldWoff from "@fonts/gantmodern-bold.woff";
import GantModernBoldWoff2 from "@fonts/gantmodern-bold.woff2";
import GantModernMediumWoff from "@fonts/gantmodern-medium.woff";
import GantModernMediumWoff2 from "@fonts/gantmodern-medium.woff2";
import GantModernRegularWoff from "@fonts/gantmodern-regular.woff";
import GantModernRegularWoff2 from "@fonts/gantmodern-regular.woff2";
import GantSerifMediumCondensedWoff from "@fonts/gantserif-medium-condensed.woff";
import GantSerifMediumCondensedWoff2 from "@fonts/gantserif-medium-condensed.woff2";
import GantVarsitySanRegularWoff from "@fonts/gantvarsity-sans-regular.woff";
import GantVarsitySanRegularWoff2 from "@fonts/gantvarsity-sans-regular.woff2";

const GlobalFonts = () => {
  const { loadFonts } = useContext(LoadContext);

  useEffect(() => {
    if (typeof loadFonts === "function") {
      loadFonts({
        families: [
          "univers-light",
          "univers-roman",
          "univers-bold",
          "univers-bold-cond",
          "gantmodern-bold",
          "gantmodern-medium",
          "gantmodern-regular",
          "gantserif-medium-condensed",
          "gantvarsity-sans-regular",
        ],
      });
    }
  }, [loadFonts]);

  return (
    <Global
      styles={css`
        @font-face {
          font-family: "univers-light";
          src: local("univers-light"), url(${UniversLightWoff2}) format("woff2"),
            url(${UniversLightWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-roman";
          src: local("univers-roman"), url(${UniversRomanWoff2}) format("woff2"),
            url(${UniversRomanWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-bold";
          src: local("univers-bold"), url(${UniversBoldWoff2}) format("woff2"),
            url(${UniversBoldWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-bold-cond";
          src: local("univers-bold-cond"),
            url(${UniversBoldCondWoff2}) format("woff2"),
            url(${UniversBoldCondWoff}) format("woff");
        }

        @font-face {
          font-family: "gantmodern-bold";
          src: local("gantmodern-bold"),
            url(${GantModernBoldWoff2}) format("woff2"),
            url(${GantModernBoldWoff}) format("woff");
        }

        @font-face {
          font-family: "gantmodern-medium";
          src: local("gantmodern-medium"),
            url(${GantModernMediumWoff2}) format("woff2"),
            url(${GantModernMediumWoff}) format("woff");
        }

        @font-face {
          font-family: "gantmodern-regular";
          src: local("gantmodern-regular"),
            url(${GantModernRegularWoff2}) format("woff2"),
            url(${GantModernRegularWoff}) format("woff");
        }

        @font-face {
          font-family: "gantserif-medium-condensed";
          src: local("gantserif-medium-condensed"),
            url(${GantSerifMediumCondensedWoff2}) format("woff2"),
            url(${GantSerifMediumCondensedWoff}) format("woff");
        }

        @font-face {
          font-family: "gantvarsity-sans-regular";
          src: local("gantvarsity-sans-regular"),
            url(${GantVarsitySanRegularWoff2}) format("woff2"),
            url(${GantVarsitySanRegularWoff}) format("woff");
        }
      `}
    />
  );
};

export default GlobalFonts;
